import $ from 'jquery/dist/jquery.min';
const hcSticky = require( 'hc-sticky/dist/hc-sticky' );
import classie from '../plugins/classie/1.0.1/classie.min';

$( document ).ready( f => {
  const $stickyBookNow = $( '#sticky_book_now' );
  if ( $stickyBookNow.length > 0 ) {
    const top = parseInt( $stickyBookNow.css( 'margin-bottom' ).split( 'px' )[0]);

    const sticky = $.fn.initHcSticky( '#sticky_book_now', top );

    let init = false;
    $( window ).on( 'scroll', e => {
      const $data_init_responsive_tabs = $( '[data-init-reponsive-tabs="dropdownfx"]' );

      if ( $data_init_responsive_tabs && $data_init_responsive_tabs.length > 0 && !init ) {
        init = true;
        $data_init_responsive_tabs.each( function () {
          var drop = $( this );
          drop.addClass( "d-none d-md-flex d-lg-flex d-xl-flex" );
          var content = '<select class="cs-select cs-skin-slide full-width" data-init-plugin="cs-select">'
          for ( var i = 1; i <= drop.children( "li" ).length; i++ ) {
            var li = drop.children( "li:nth-child(" + i + ")" );
            var selected = "";
            if ( li.children( 'a' ).hasClass( "active" ) ) {
              selected = "selected";
            }
            var tabRef = li.children( 'a' ).attr( 'href' );
            if ( tabRef == "#" || "" ) {
              tabRef = li.children( 'a' ).attr( 'data-bs-target' )
            }
            content += '<option value="' + tabRef + '" ' + selected + '>';
            content += li.children( 'a' ).text();
            content += '</option>';
          }
          content += '</select>'
          drop.after( content );
          var select = drop.next()[0];
          $( select ).on( 'change', function ( e ) {
            var optionSelected = $( "option:selected", this );
            var valueSelected = this.value;
            var tabLink = drop.find( 'a[data-bs-target="' + valueSelected + '"]' );
            if ( tabLink.length == 0 ) {
              tabLink = drop.find( 'a[data-bs-target="' + valueSelected + '"]' )
            }
            console.log( 'a[data-target="' + valueSelected + '"]' )
            console.log( tabLink )
            console.log( this.value )
            tabLink.tab( 'show' )
          })
          $( select ).wrap( '<div class="nav-tab-dropdown cs-wrapper full-width d-lg-none d-xl-none d-md-none"></div>' );
          new SelectFx( select );
        });
      }
    });
  }
  // elements.$jumbotron.css('margin-top', elements.$header.height());
});

( function ( $ ) {
  $.fn.initHcSticky = ( id, top, sticky ) => {
    //-------- Only for Desktop --------
    if ( $( window ).width() > 768 && sticky == null ) {
      sticky = new hcSticky( id, {
        top: top
      });
    }
    return sticky;
  };
  $.fn.remToPx = rem => {
    return rem / 0.0625;
  };
  $.fn.initElements = ( elements ) => {
    elements.$window = $( window );
    elements.$header = $( 'header' );
    elements.$jumbotron = $( '.jumbotron' );
  };
  $.fn.headerFixedToggle = ( $window, $header ) => {
    if ( $window.scrollTop() > $header.scrollTop() ) {
      $header.removeClass( 'position-relative' );
    } else {
      $header.addClass( 'position-relative' );
    }
  };
  $.fn.headerFixedToggleOnScroll = ( $window, $header ) => {

    $window.scroll( action => {
      console.log( $header.scrollTop() )
      $.fn.headerFixedToggle( $window, $header );
    })
  };

  $.fn.stickyElement = ( $stickyStart, $stickyStop, $stickyElement ) => {
    var scroll = 0;
    var bottom = 0;

    const $stickyElementTop = $stickyElement.position().top;
    const $stickyElementOuterHeight = $stickyElement.outerHeight( true );
    const $stickyElementParent = $stickyElement.parent();

    //const $stickyStartHeight =  $stickyStart.outerHeight(true) + 30;
    const $stickyStartHeight = 30;

    $.fn.stickyElementConditions( scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop );

    $( window ).on( 'scroll', f => {
      $.fn.stickyElementConditions( scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop );
    }).on( 'resize', f => {
      $.fn.stickyElementConditions( scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop );
    });
  };

  $.fn.stickyElementConditions = ( scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop ) => {
    scroll = $( window ).scrollTop() + $stickyStartHeight;
    bottom = $( window ).scrollTop() + $stickyStartHeight + $stickyElementOuterHeight + 30;

    if ( $( window ).width() > 991 ) {
      if ( bottom >= $stickyStop.position().top ) {
        $stickyElementParent.addClass( 'd-flex flex-column' );
        $stickyElement.removeClass( 'position-fixed' );
        $stickyElement.css( 'top', 'unset' );
        $stickyElement.css( 'margin-top', 'auto' );
        $stickyElement.css( 'width', $stickyElementParent.width() );
      } else {
        if ( scroll >= $stickyElementTop ) {
          $stickyElement.addClass( 'position-fixed' );

          $stickyElement.css( 'top', $stickyStartHeight );
          $stickyElement.css( 'width', $stickyElementParent.width() );

        } else {
          $stickyElement.removeClass( 'position-fixed' );
          $stickyElement.css( 'top', 'unset' );
          $stickyElement.css( 'width', 'auto' );
        }
        $stickyElement.css( 'margin-top', 'unset' );
      }
    } else {
      $stickyElement.removeClass( 'position-fixed' );
      $stickyElement.css( 'top', 'unset' );
      $stickyElement.css( 'width', 'auto' );
      $stickyElement.css( 'margin-top', 'unset' );
    }
  }

})( $ );

/**
 * selectFx.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2014, Codrops
 * http://www.codrops.com
 */
;
( function ( window ) {

  'use strict';

  /**
   * based on from https://github.com/inuyaksa/jquery.nicescroll/blob/master/jquery.nicescroll.js
   */
  function hasParent ( e, p ) {
    if ( !e ) return false;
    var el = e.target || e.srcElement || e || false;
    while ( el && el != p ) {
      el = el.parentNode || false;
    }
    return ( el !== false );
  };

  /**
   * extend obj function
   */
  function extend ( a, b ) {
    for ( var key in b ) {
      if ( b.hasOwnProperty( key ) ) {
        a[key] = b[key];
      }
    }
    return a;
  }

  /**
   * SelectFx function
   */
  function SelectFx ( el, options ) {
    this.el = el;
    this.options = extend({}, this.options );
    extend( this.options, options );
    this._init();
  }

  /**
   * Pure-JS alternative to jQuery closest()
   */
  function closest ( elem, selector ) {
    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
    while ( elem ) {
      if ( matchesSelector.bind( elem )( selector ) ) {
        return elem;
      } else {
        elem = elem.parentElement;
      }
    }
    return false;
  }

  /**
   * jQuery offset() in pure JS
   */
  function offset ( el ) {
    return {
      left: el.getBoundingClientRect().left + window.pageXOffset - el.ownerDocument.documentElement.clientLeft,
      top: el.getBoundingClientRect().top + window.pageYOffset - el.ownerDocument.documentElement.clientTop
    }

  }

  /**
   * jQuery after() in pure JS
   */
  function insertAfter ( newNode, referenceNode ) {
    referenceNode.parentNode.insertBefore( newNode, referenceNode.nextSibling );
  }
  /**
   * SelectFx options
   */
  SelectFx.prototype.options = {
    // if true all the links will open in a new tab.
    // if we want to be redirected when we click an option, we need to define a data-link attr on the option of the native select element
    newTab: true,
    // when opening the select element, the default placeholder (if any) is shown
    stickyPlaceholder: true,
    // default container is body
    container: 'body',
    // callback when changing the value
    onChange: function ( el ) {
      var event = document.createEvent( 'HTMLEvents' );
      event.initEvent( 'change', true, false );
      el.dispatchEvent( event );
    }
  }

  /**
   * init function
   * initialize and cache some vars
   */
  SelectFx.prototype._init = function () {
    // check if we are using a placeholder for the native select box
    // we assume the placeholder is disabled and selected by default
    var selectedOpt = document.querySelector( 'option[selected]' );
    this.hasDefaultPlaceholder = selectedOpt && selectedOpt.disabled;

    // get selected option (either the first option with attr selected or just the first option)
    this.selectedOpt = selectedOpt || this.el.querySelector( 'option' );

    // create structure
    this._createSelectEl();

    // all options
    this.selOpts = [].slice.call( this.selEl.querySelectorAll( 'li[data-option]' ) );

    // total options
    this.selOptsCount = this.selOpts.length;

    // current index
    this.current = this.selOpts.indexOf( this.selEl.querySelector( 'li.cs-selected' ) ) || -1;

    // placeholder elem
    this.selPlaceholder = this.selEl.querySelector( 'span.cs-placeholder' );

    // init events
    this._initEvents();

    this.el.onchange = function () {
      var index = this.selectedIndex;
      var inputText = this.children[index].innerHTML.trim();
    }

  }

  /**
   * creates the structure for the select element
   */
  SelectFx.prototype._createSelectEl = function () {
    var self = this,
      options = '',
      createOptionHTML = function ( el ) {
        var optclass = '',
          classes = '',
          link = '';

        if ( el.selectedOpt && !this.foundSelected && !this.hasDefaultPlaceholder ) {
          classes += 'cs-selected ';
          this.foundSelected = true;
        }
        // extra classes
        if ( el.getAttribute( 'data-class' ) ) {
          classes += el.getAttribute( 'data-class' );
        }
        // link options
        if ( el.getAttribute( 'data-link' ) ) {
          link = 'data-link=' + el.getAttribute( 'data-link' );
        }

        if ( classes !== '' ) {
          optclass = 'class="' + classes + '" ';
        }

        return '<li ' + optclass + link + ' data-option data-value="' + el.value + '"><span>' + el.textContent + '</span></li>';
      };

    [].slice.call( this.el.children ).forEach( function ( el ) {
      if ( el.disabled ) {
        return;
      }

      var tag = el.tagName.toLowerCase();

      if ( tag === 'option' ) {
        options += createOptionHTML( el );
      } else if ( tag === 'optgroup' ) {
        options += '<li class="cs-optgroup"><span>' + el.label + '</span><ul>';
        [].slice.call( el.children ).forEach( function ( opt ) {
          options += createOptionHTML( opt );
        })
        options += '</ul></li>';
      }
    });

    var opts_el = '<div class="cs-options"><ul>' + options + '</ul></div>';
    this.selEl = document.createElement( 'div' );
    this.selEl.className = this.el.className;
    this.selEl.tabIndex = this.el.tabIndex;
    this.selEl.innerHTML = '<span class="cs-placeholder">' + this.selectedOpt.textContent + '</span>' + opts_el;
    this.el.parentNode.appendChild( this.selEl );
    this.selEl.appendChild( this.el );

    // backdrop to support dynamic heights of the dropdown
    var backdrop = document.createElement( 'div' );
    backdrop.className = 'cs-backdrop';
    this.selEl.appendChild( backdrop );
  }

  /**
   * initialize the events
   */
  SelectFx.prototype._initEvents = function () {
    var self = this;

    // open/close select
    this.selPlaceholder.addEventListener( 'click', function () {
      self._toggleSelect();
    });

    // clicking the options
    this.selOpts.forEach( function ( opt, idx ) {
      opt.addEventListener( 'click', function () {
        self.current = idx;
        self._changeOption();
        // close select elem
        self._toggleSelect();
      });
    });

    // close the select element if the target it´s not the select element or one of its descendants..
    document.addEventListener( 'click', function ( ev ) {
      var target = ev.target;
      if ( self._isOpen() && target !== self.selEl && !hasParent( target, self.selEl ) ) {
        self._toggleSelect();
      }
    });

    // keyboard navigation events
    this.selEl.addEventListener( 'keydown', function ( ev ) {
      var keyCode = ev.keyCode || ev.which;

      switch ( keyCode ) {
      // up key
      case 38:
        ev.preventDefault();
        self._navigateOpts( 'prev' );
        break;
        // down key
      case 40:
        ev.preventDefault();
        self._navigateOpts( 'next' );
        break;
        // space key
      case 32:
        ev.preventDefault();
        if ( self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1 ) {
          self._changeOption();
        }
        self._toggleSelect();
        break;
        // enter key
      case 13:
        ev.preventDefault();
        if ( self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1 ) {
          self._changeOption();
          self._toggleSelect();
        }
        break;
        // esc key
      case 27:
        ev.preventDefault();
        if ( self._isOpen() ) {
          self._toggleSelect();
        }
        break;
      }
    });
  }

  /**
   * navigate with up/dpwn keys
   */
  SelectFx.prototype._navigateOpts = function ( dir ) {
    if ( !this._isOpen() ) {
      this._toggleSelect();
    }

    var tmpcurrent = typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1 ? this.preSelCurrent : this.current;

    if ( dir === 'prev' && tmpcurrent > 0 || dir === 'next' && tmpcurrent < this.selOptsCount - 1 ) {
      // save pre selected current - if we click on option, or press enter, or press space this is going to be the index of the current option
      this.preSelCurrent = dir === 'next' ? tmpcurrent + 1 : tmpcurrent - 1;
      // remove focus class if any..
      this._removeFocus();
      // add class focus - track which option we are navigating
      classie.add( this.selOpts[this.preSelCurrent], 'cs-focus' );
    }
  }

  /**
   * open/close select
   * when opened show the default placeholder if any
   */
  SelectFx.prototype._toggleSelect = function () {
    var backdrop = this.selEl.querySelector( '.cs-backdrop' );
    var container = document.querySelector( this.options.container );
    var mask = container.querySelector( '.dropdown-mask' );
    var csOptions = this.selEl.querySelector( '.cs-options' );
    var csPlaceholder = this.selEl.querySelector( '.cs-placeholder' );

    var csPlaceholderWidth = csPlaceholder.offsetWidth;
    var csPlaceholderHeight = csPlaceholder.offsetHeight;
    var csOptionsWidth = csOptions.scrollWidth;

    if ( this._isOpen() ) {
      if ( this.current !== -1 ) {
        // update placeholder text
        this.selPlaceholder.textContent = this.selOpts[this.current].textContent;
      }

      var dummy = this.selEl.data;

      var parent = dummy.parentNode;
      //parent.appendChild(this.selEl);
      insertAfter( this.selEl, dummy );
      this.selEl.removeAttribute( 'style' );

      parent.removeChild( dummy );

      // Hack for FF
      // http://stackoverflow.com/questions/12088819/css-transitions-on-new-elements
      var x = this.selEl.clientHeight;

      // reset backdrop
      backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = 'scale3d(1,1,1)';
      classie.remove( this.selEl, 'cs-active' );

      mask.style.display = 'none';
      csOptions.style.overflowY = 'hidden';
      csOptions.style.width = 'auto';

      var parentFormGroup = closest( this.selEl, '.form-group' );
      parentFormGroup && classie.removeClass( parentFormGroup, 'focused' );

    } else {
      if ( this.hasDefaultPlaceholder && this.options.stickyPlaceholder ) {
        // everytime we open we wanna see the default placeholder text
        this.selPlaceholder.textContent = this.selectedOpt.textContent;
      }

      var dummy;
      if ( this.selEl.parentNode.querySelector( '.dropdown-placeholder' ) ) {
        dummy = this.selEl.parentNode.querySelector( '.dropdown-placeholder' );
      } else {
        dummy = document.createElement( 'div' );
        classie.add( dummy, 'dropdown-placeholder' );
        //this.selEl.parentNode.appendChild(dummy);
        insertAfter( dummy, this.selEl );

      }


      dummy.style.height = csPlaceholderHeight + 'px';
      dummy.style.width = this.selEl.offsetWidth + 'px';

      this.selEl.data = dummy;



      this.selEl.style.position = 'absolute';
      var offsetselEl = offset( this.selEl );

      this.selEl.style.left = offsetselEl.left + 'px';
      this.selEl.style.top = offsetselEl.top + 'px';

      container.appendChild( this.selEl );

      // decide backdrop's scale factor depending on the content height
      var contentHeight = csOptions.offsetHeight;
      var originalHeight = csPlaceholder.offsetHeight;

      var contentWidth = csOptions.offsetWidth;
      var originalWidth = csPlaceholder.offsetWidth;

      var scaleV = contentHeight / originalHeight;
      var scaleH = ( contentWidth > originalWidth ) ? contentWidth / originalWidth : 1.05;
      //backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = 'scale3d(' + scaleH + ', ' + scaleV + ', 1)';
      backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = 'scale3d(' + 1 + ', ' + scaleV + ', 1)';

      if ( !mask ) {
        mask = document.createElement( 'div' );
        classie.add( mask, 'dropdown-mask' );
        container.appendChild( mask );
      }

      mask.style.display = 'block';

      classie.add( this.selEl, 'cs-active' );

      var resizedWidth = ( csPlaceholderWidth < csOptionsWidth ) ? csOptionsWidth : csPlaceholderWidth;

      this.selEl.style.width = resizedWidth + 'px';
      this.selEl.style.height = originalHeight + 'px';
      csOptions.style.width = '100%';

      setTimeout( function () {
        csOptions.style.overflowY = 'auto';
      }, 300 );

    }
  }

  /**
   * change option - the new value is set
   */
  SelectFx.prototype._changeOption = function () {
    // if pre selected current (if we navigate with the keyboard)...
    if ( typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1 ) {
      this.current = this.preSelCurrent;
      this.preSelCurrent = -1;
    }

    // current option
    var opt = this.selOpts[this.current];

    // update current selected value
    this.selPlaceholder.textContent = opt.textContent;

    // change native select element´s value
    this.el.value = opt.getAttribute( 'data-value' );

    // remove class cs-selected from old selected option and add it to current selected option
    var oldOpt = this.selEl.querySelector( 'li.cs-selected' );
    if ( oldOpt ) {
      classie.remove( oldOpt, 'cs-selected' );
    }
    classie.add( opt, 'cs-selected' );

    // if there´s a link defined
    if ( opt.getAttribute( 'data-link' ) ) {
      // open in new tab?
      if ( this.options.newTab ) {
        window.open( opt.getAttribute( 'data-link' ), '_blank' );
      } else {
        window.location = opt.getAttribute( 'data-link' );
      }
    }

    // callback
    this.options.onChange( this.el );
  }

  /**
   * returns true if select element is opened
   */
  SelectFx.prototype._isOpen = function ( opt ) {
    return classie.has( this.selEl, 'cs-active' );
  }

  /**
   * removes the focus class from the option
   */
  SelectFx.prototype._removeFocus = function ( opt ) {
    var focusEl = this.selEl.querySelector( 'li.cs-focus' )
    if ( focusEl ) {
      classie.remove( focusEl, 'cs-focus' );
    }
  }

  /**
   * add to global namespace
   */
  window.SelectFx = SelectFx;

})( window );
